import { Link } from 'react-router-dom';
import { Box, Button, styled, Card } from '@harver/shared-ui';

export const Wrapper = styled(Card)`
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: ${({ theme }) => theme.getSpacing(220)};
    padding: ${({ theme }) => theme.sizes.xLarge};

    /* TODO: Unify how we use media queries */
    // @media (min-width: 321px) {
    //     margin: 0 ${({ theme }) => theme.sizes.medium};
    //     padding: ${({ theme }) => theme.sizes.xLarge};
    // }
    //
    // /* TODO: Unify how we use media queries */
    // @media (min-width: 768px) {
    //     padding: ${({ theme }) => '0 ' + theme.getSpacing(25)};
    // }
`;

export const ConfirmationMessage = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${({ theme }) => theme.sizes.xxLarge};
    margin-bottom: ${({ theme }) => theme.sizes.large};
    padding: 4% 6%;
    background-color: ${({ theme }) => theme.colors.neutral['025']};
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.neutral['100']};
`;

export const PickerButton: any = styled(Button)`
    min-width: ${({ theme }) => theme.getSpacing(35)};
    margin-right: ${({ theme }) => theme.sizes.xSmall};
    margin-bottom: ${({ theme }) => theme.sizes.xSmall};
    border: ${({ theme }) => `solid 1px ${theme.colors.primary[500]}`};
    border-radius: ${({ theme }) => theme.button.borderRadius};
    color: ${({ theme, isSelected }: any) => (isSelected ? theme.colors.neutral['000'] : theme.colors.primary[500])};
    background-color: ${({ theme, isSelected }: any) =>
        isSelected ? theme.colors.primary[500] : theme.colors.neutral['000']};

    &:hover {
        background-color: ${({ theme }) => theme.colors.primary[600]};
        border-color: ${({ theme }) => theme.colors.primary[600]};
        color: ${({ theme }) => theme.colors.neutral['000']};
    }

    &[disabled] {
        background-color: ${({ theme }) => theme.colors.primary[500]};
        border-color: ${({ theme }) => theme.colors.primary[500]};
        color: ${({ theme }) => theme.colors.neutral['000']};
    }
`;

export const PickerWrapper = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
`;

export const StyledLink = styled(Link)`
    color: ${({ theme }) => theme.colors.neutral[900]};
`;
